export const holidayDates = [
  {
    date: '2025-08-17',
    day: 'Minggu',
    description: 'Hari Kemerdekaan Republik Indonesia'
  },
  {
    date: '2025-09-05',
    day: 'Jumat',
    description: 'Maulid Nabi Muhammad SAW'
  },
  {
    date: '2025-12-25',
    day: 'Kamis',
    description: 'Hari Raya Natal'
  }
]

export function emptyMonitoringKonsultan () {
  const result = {
    consultants: [],
    timeslots: [
      '08:00',
      '08:30',
      '09:00',
      '09:30',
      '10:00',
      '10:30',
      '11:00',
      '11:30',
      '12:00',
      '12:30',
      '13:00',
      '13:30',
      '14:00',
      '14:30',
      '15:00',
      '15:30',
      '16:00',
      '16:30',
      '17:00',
      '17:30',
      '18:00'
    ],
    surveys: [],
    custom_surveys: []
  }
  const data = 20
  for (let i = 0; i < data; i++) result.consultants.push({})
  return result
}
